import { getFlattenedOptions } from './getFlattenedOptions';

export const countAllOptions = (options) => getFlattenedOptions(options).length;
